module.exports = __webpack_public_path__ + "static/media/twitterLight.3920c8b5.svg";